module.exports = __webpack_public_path__ + "img/max_deposit_ntd_mobile4.51db46ee.png";